import styled from 'styled-components';

const ModuleLessonsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const ModuleLessonContainer = styled.div`
  cursor: pointer;
  transition: all 0.3s;
  border-radius: 5px;

  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }

  &.locked {
    cursor: not-allowed;
  }

  display: flex;
  align-items: stretch;
`;

const LessonFlux = styled.div`
  padding: 0 5px;
  min-height: 50px;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

const fluxStyle = `&.locked {
  color: #657787;
  background: #C0C0C0;
}

&.unlocked {
  color: #1d2680;
  background: #B6ED68;

}

&.finished {
  background: var(--primary-blue)	;
  color: var(--light-gray);
}`;

const LessonFluxCircle = styled.div`
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  ${fluxStyle}
`;

const LessonFluxUpperBar = styled.span`
  border: solid 1px #657787;
  flex-grow: 1;

  ${fluxStyle}

  &.first {
    visibility: hidden;
  }
`;

const LessonFluxLowerBar = styled.span`
  border: solid 1px #657787;
  flex-grow: 1;

  ${fluxStyle}

  &.last {
    visibility: hidden;
  }
`;

const LessonContent = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 5px;
`;

const LessonDuration = styled.div`
  background: var(--primary-blue);
  color: white;
  padding: 5px;
  border-radius: 5px;
  white-space: nowrap;
`;

const LessonTitle = styled.p`
  &.selected {
    font-weight: bold;
  }
`;

export {
  ModuleLessonsContainer,
  ModuleLessonContainer,
  LessonFlux,
  LessonContent,
  LessonDuration,
  LessonTitle,
  LessonFluxCircle,
  LessonFluxLowerBar,
  LessonFluxUpperBar,
};
